import UsersResources from './users'
import AuthResource from './auth'
import MagazinesResource from './magazines'
import PagesResource from './pages'
import TemplatesResource from './templates'
import UploadResource from './uploads'
import PublishResource from './publish'
import LanguagesResource from './languages'
import { Resources } from './resources'
export {
  Resources,
  AuthResource,
  UsersResources,
  MagazinesResource,
  PublishResource,
  PagesResource,
  TemplatesResource, 
  UploadResource,
  LanguagesResource
}



// WEBPACK FOOTER //
// ./src/resources/index.js